import type { AuthUser } from '@/shared/types/auth';
import { setTokens } from '@/shared/lib/storage/token';

type SessionPayload = {
  accessToken?: string;
  refreshToken?: string;
  user?: AuthUser;
  message?: string;
  data?: {
    accessToken?: string;
    refreshToken?: string;
    user?: AuthUser;
    sessionId?: string;
  };
  sessionId?: string;
};

function normalizePermissionName(entry: unknown): string | undefined {
  if (typeof entry === 'string') return entry;
  if (entry && typeof entry === 'object') {
    const obj = entry as { name?: string; permission?: string };
    return obj.name || obj.permission;
  }
  return undefined;
}

export function normalizeUserPermissions(user: AuthUser): AuthUser {
  if (!Array.isArray(user.flatPermissions)) return user;
  const permissions = user.flatPermissions
    .map(normalizePermissionName)
    .filter((name): name is string => Boolean(name));
  return { ...user, permissions };
}

export function applySession(data: unknown): AuthUser | null {
  const payload = data as SessionPayload;
  const accessToken = payload.accessToken ?? payload.data?.accessToken;
  const refreshToken = payload.refreshToken ?? payload.data?.refreshToken;
  const user = payload.user ?? payload.data?.user;

  if (accessToken) setTokens(accessToken, refreshToken);
  return user ? normalizeUserPermissions(user) : null;
}

export function getApiMessage(data: unknown, fallback: string): string {
  const payload = data as SessionPayload;
  return payload.message || fallback;
}

export function getSessionId(data: unknown): string | undefined {
  const payload = data as SessionPayload;
  return payload.data?.sessionId ?? payload.sessionId;
}

export function phoneOtpNavState() {
  return {
    type: 'Phone' as const,
    email: localStorage.getItem('user_email') || '',
    mobileNumber: localStorage.getItem('user_mobile') || '',
  };
}
